import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import TextInput from "../../../components/form-fields/TextInput";
import { FormGroup } from "../../../components/forms";
import { policyHolderDetailsValidations } from "../../../helpers/group_travel/validations";
import useForm from "../../../hooks/useForm";
import AuGroupBusinessFormStepNavigation from "../Form/CreateQuoteStepNavigation";
import GroupTravelHeading from "../components/Heading";
import { BindContext } from "../BindQuote";
import SelectInput from "../../../components/form-fields/SelectInput";
import { States } from "../enums/forms/DomicileRegion";
import { removeExtraSpaces } from "../../../helpers/shared/formHandlers";

type Props = {
  onNext: VoidFunction | null;
  onPrevious: VoidFunction | null;
};

const PolicyHolderDetails: FC<Props> = ({ onNext, onPrevious }) => {
  const { t } = useTranslation("pages", { keyPrefix: "groupTravel.newProduct.bind" });
  const { state, setFormState, onChange } = useContext(BindContext);
  const { field, validateField, validateForm } = useForm(state, policyHolderDetailsValidations, onChange);
  const handleNext = () => validateForm(() => onNext?.());
  const redirectToAbn = () => window.open("https://abr.business.gov.au/", "_blank", "noreferrer");

  return (
    <>
      <div className="container-flow flex-grow">
        <GroupTravelHeading title={t("policyHolder.policyHolderDetails")} alt="GroupTravel" />
        <FormGroup title={t("policyHolder.policyholderName")}>
          <TextInput
            aria-label="policyHolder-name"
            value={state.policyHoldersName}
            {...field.policyHoldersName}
            label={t("policyHolder.policyholderName")}
            disabled={true}
          />
        </FormGroup>
        <FormGroup title={t("policyHolder.policyHolderAddress")}>
          <TextInput
            aria-label={`streetNumber`}
            value={state.streetNumber}
            {...field.streetNumber}
            label={t("policyHolder.streetNumber")}
            onBlur={removeExtraSpaces("streetNumber", setFormState, validateField)}
          />
          <TextInput
            aria-label={`unitNumber`}
            value={state.unitNumber}
            {...field.unitNumber}
            label={t("policyHolder.unitNumber")}
            onBlur={removeExtraSpaces("unitNumber", setFormState, validateField)}
          />
          <TextInput
            aria-label={`floorNumber`}
            value={state.floorNumber}
            {...field.floorNumber}
            label={t("policyHolder.floorNumber")}
            onBlur={removeExtraSpaces("floorNumber", setFormState, validateField)}
          />
          <TextInput
            aria-label={`street`}
            value={state.streetName}
            {...field.streetName}
            label={t("policyHolder.streetName")}
            onBlur={removeExtraSpaces("streetName", setFormState, validateField)}
          />
          <TextInput
            aria-label={`suburb`}
            value={state.suburb}
            {...field.suburb}
            label={t("policyHolder.suburb")}
            onBlur={removeExtraSpaces("suburb", setFormState, validateField)}
          />
          <SelectInput
            aria-label={`region`}
            label={t("formProperties.selectState")}
            value={state.state}
            options={Object.values(States).sort()}
            disabled={false}
            {...field.state}
          />
          <TextInput
            aria-label={`postal`}
            value={state.postalCode}
            {...field.postalCode}
            label={t("policyHolder.postal")}
            onBlur={removeExtraSpaces("postalCode", setFormState, validateField)}
          />
        </FormGroup>
        <FormGroup
          className="relative whitespace-nowrap md:h-15"
          onHyperLink={() => redirectToAbn()}
          hyperLinkText={t("policyHolder.abnLookUp")}
          title={t("policyHolder.AustralianBusinessNumber")}
        >
          <TextInput
            aria-label="policyHolder-AustralianBusinessNumber"
            value={state.australiaBusinessNo}
            {...field.australiaBusinessNo}
            label={t("policyHolder.AustralianBusinessNumber")}
            onBlur={removeExtraSpaces("australiaBusinessNo", setFormState, validateField)}
          />
        </FormGroup>
      </div>
      <AuGroupBusinessFormStepNavigation isLoading={false} onBack={onPrevious} onNext={handleNext} />
    </>
  );
};

export default PolicyHolderDetails;
